import api from "@/lib/api";
import { WORK } from "@/studio/data/work";

/**
 * Maps a backend Project document to the shape the studio UI expects.
 * The public site is now driven by the database (admin = source of truth);
 * the static WORK array is only used as an offline/error fallback so the page
 * never blanks out.
 */
export function mapProject(raw, i, total) {
  const mock = raw.mock || "dashboard";
  const screens = Array.isArray(raw.screens) && raw.screens.length ? raw.screens : [mock];
  return {
    slug: raw.slug,
    name: raw.title,
    index: String(i + 1).padStart(2, "0"),
    total: String(total).padStart(2, "0"),
    category: raw.category || "",
    year: raw.year || "",
    accent: raw.accent || "#E4FF00",
    tagline: raw.tagline || raw.short_description || "",
    challenge: raw.challenge || raw.full_description || "",
    solution: raw.solution || raw.case_study || "",
    outcome: Array.isArray(raw.outcome) ? raw.outcome : [],
    stack: Array.isArray(raw.technologies) ? raw.technologies : [],
    services: Array.isArray(raw.services) ? raw.services : [],
    cover: raw.cover_image || "",
    gallery: Array.isArray(raw.gallery_images) ? raw.gallery_images.filter(Boolean) : [],
    mock,
    screens,
  };
}

function staticFallback() {
  const total = WORK.length;
  return WORK.map((w, i) => ({
    ...w,
    cover: w.cover || "",
    gallery: Array.isArray(w.gallery) ? w.gallery : [],
    index: String(i + 1).padStart(2, "0"),
    total: String(total).padStart(2, "0"),
  }));
}

/**
 * Fetch the published portfolio from the backend, mapped + sorted.
 * Returns the static fallback on any failure or empty result.
 */
export async function fetchWork() {
  try {
    const { data } = await api.get("/projects", { params: { published: true } });
    if (!Array.isArray(data) || data.length === 0) return staticFallback();
    return data.map((raw, i) => mapProject(raw, i, data.length));
  } catch (e) {
    return staticFallback();
  }
}
